import React from "react";
import {Tag} from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useTranslate} from "../../../../../hooks/translate.hook";
import {HealthCheckStatus} from "../../../../../models/health-checker/health-checker";

interface HealthCenterCheckStatusProps {
    status: HealthCheckStatus;
}

export const HealthCenterCheckStatus: React.FC<HealthCenterCheckStatusProps> = ({status}) => {
    const t = useTranslate();
    const isOk = status === "ok";

    return (
        <Tag
            className="health-center-checks__status"
            color={isOk ? "success" : "error"}
            icon={<FontAwesomeIcon icon={["fas", isOk ? "check-circle" : "exclamation-triangle"]} />}
        >
            {isOk
                ? t("HEALTH-CENTER.SETTINGS.CHECKS.STATUS.OK", {defaultValue: "OK"})
                : t("HEALTH-CENTER.SETTINGS.CHECKS.STATUS.NOT-OK", {defaultValue: "Not OK"})}
        </Tag>
    );
};
